import { render, staticRenderFns } from "./SoldApplianceDetail.vue?vue&type=template&id=4a50b154&scoped=true"
import script from "./SoldApplianceDetail.vue?vue&type=script&lang=js"
export * from "./SoldApplianceDetail.vue?vue&type=script&lang=js"
import style0 from "./SoldApplianceDetail.vue?vue&type=style&index=0&id=4a50b154&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a50b154",
  null
  
)

export default component.exports